import { Container as MaterialContainer, ContainerProps as MaterialContainerProps } from '@mui/material';
import React from 'react';

const DEFAULT_MAXWIDTH = 'lg';

interface ContainerProps extends Omit<MaterialContainerProps<'div'>, 'component'> {
  component?: 'div' | 'footer' | 'header';
}

/**
 * The Container
 *
 * @version [AIV]{version}[/AIV]
 * @author [SFP](https://gitlab.sfp.berlin/products/sparkasse.de/portals)
 */
export const Container: React.FC<ContainerProps> = ({
  children,
  maxWidth = DEFAULT_MAXWIDTH,
  ...props
}: ContainerProps) => {
  return (
    <MaterialContainer component="div" maxWidth={maxWidth} {...props}>
      {children}
    </MaterialContainer>
  );
};

export type { ContainerProps };
